// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__37kkx","consentsList":"PatientConsents_consentsList__1tGpH","consentsListEmpty":"PatientConsents_consentsListEmpty__38xD0"};